export default "__VITE_ASSET__DyHef2e2__"